
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14 5H10V9H7L12 14L17 9H14V5Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.7318 12.0364C17.3098 12.1536 17 12.5406 17 13V13.5L17.7318 12.0364ZM14 16H8C7.44772 16 7 15.5523 7 15V13C7 12.4477 6.55228 12 6 12H4C3.44772 12 3 12.4477 3 13V18C3 18.5523 3.44772 19 4 19H10.7L13.5 17L14 16C14 16 14 16 14 16Z"></path><path d="M20.6206 12.2721L20.1779 12.0647C19.8449 11.9091 19.4443 12.0437 19.2836 12.3672L17.8075 15.3235L17.7194 15.2815C16.9016 14.8999 15.9193 15.2309 15.525 16.0224L15.3975 16.278L20.1843 18.5156L20.3119 18.26C20.7061 17.4685 20.3642 16.5176 19.5464 16.136L19.4584 16.0953L20.9332 13.139C21.0939 12.8155 20.9549 12.4277 20.6206 12.2721ZM19.9789 18.9244L15.1857 16.6843C14.8935 17.0548 14.5159 17.4722 14.0362 17.8871C13.3026 18.5218 12.5754 18.9404 12 19.2133C12.1671 19.7246 12.5205 19.9703 12.7693 20.2296C12.8612 20.3259 14.2786 18.8429 14.3807 18.9379C14.4827 19.033 13.2707 20.705 13.3817 20.7977C13.7121 21.0718 14.0834 21.3336 14.4878 21.5793C14.5707 21.63 16.339 19.2948 16.4181 19.3368C16.5763 19.4208 15.2967 22.0214 15.4638 22.0992C15.6297 22.177 15.7968 22.2499 15.9626 22.3178C16.538 22.5524 17.1096 22.7253 17.6569 22.8389C17.824 22.8735 18.7031 19.9444 18.8638 19.9678C19.0259 19.9913 18.4709 22.9673 18.6253 22.9797C19.0909 23.0167 19.526 23.0031 19.9125 22.9389C19.7786 22.2672 19.6803 21.4003 19.7531 20.3976C19.7939 19.848 19.8794 19.3541 19.9789 18.9244Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowClearcacheFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
